export default "/images/vendor/@coreui/icons/svg/flag/cif-st.svg?4dc7e9d82bb49cf4de1b7e183bb8fa4e";